export const TRUSTAP_STATUS_OK = 'ok';
export const TRUSTAP_STATUS_INTERNAL_SERVER_ERROR = 'internal_server_error';
export const TRUSTAP_CODE_CANCELLED = 'cancelled';
export const TRUSTAP_STATUS_QUERY_KEY = 'trustap_status';
export const TRUSTAP_CODE_QUERY_KEY = 'code';
